import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const DroppableChildrenTitle = styled.span<{ isChild?: boolean, isEditTag?: boolean }>`
    font-size: 17px;
    line-height: 22px;
    color: #909090;
    font-weight: 600;
    cursor: pointer;
    transition: color 0.2s;
    padding-left: ${({ isChild }) => isChild? '24px' : '40px'};
    white-space: wrap;
    word-break: break-word;

    ${({ isEditTag }) => isEditTag && css`
        color: #151514;
    `};

    &:hover {
        color: #151514;
        transition: color 0.2s;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 15px;
        line-height: 20px;
        padding-left: 16px;
    }
`;


export const DropDownWrapper = styled(FlexBox)<{ show?: boolean }>`
    display: none;
    flex-flow: column;
${({ show }) => show && css`
    display: flex;
`}
`;import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { css } from "styled-components";

export const DroppableChildrenTitle = styled.span<{ isChild?: boolean, isEditTag?: boolean }>`
    font-size: 17px;
    line-height: 22px;
    color: #909090;
    font-weight: 600;
    cursor: pointer;
    transition: color 0.2s;
    padding-left: ${({ isChild }) => isChild? '24px' : '40px'};
    white-space: wrap;
    word-break: break-word;

    ${({ isEditTag }) => isEditTag && css`
        color: #151514;
    `};

    &:hover {
        color: #151514;
        transition: color 0.2s;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        font-size: 15px;
        line-height: 20px;
        padding-left: 16px;
    }
`;


export const DropDownWrapper = styled(FlexBox)<{ show?: boolean }>`
    display: none;
    flex-flow: column;
${({ show }) => show && css`
    display: flex;
`}
`;